import { Component, input } from '@angular/core';
import { RewardStickerComponent } from '@shared/components/challenges/elements/reward-sticker/reward-sticker.component';
import { SubType } from '@shared/constants';
import { WinCardTenthVariantConfig } from '@shared/models';
import { VariableReplacementPipe } from '@shared/pipes';

@Component({
  selector: 'b2c-variant10',
  styleUrl: './variant10.component.scss',
  templateUrl: './variant10.component.html',
  imports: [RewardStickerComponent, VariableReplacementPipe],
})
export class Variant10Component {
  amount = input<number>(0);
  subType = input<SubType>(SubType.DEFAULT);
  config = input.required<WinCardTenthVariantConfig>();
}
